
import { AnyAction } from "redux"
import { ADMIN_PRODUCTS_DASHBOARD_DATA_FAIL, ADMIN_PRODUCTS_DASHBOARD_DATA_REQ, ADMIN_PRODUCTS_DASHBOARD_DATA_SUCC } from "redux/actions/admin/dashboard/type"
 
interface State {
    loading?: boolean
    data?: any,
    error?: string,


}

const defaultState: State = {
    loading: false,
    data: [],


}


 

// export const ADMIN_PRODUCTS_DASHBOARD_DATA_FAIL="PRODUCTS_DASHBOARD_DATA_FAIL"
// export const ADMIN_PRODUCTS_DASHBOARD_DATA_REQ="PRODUCTS_DASHBOARD_DATA_REQ"
// export const ADMIN_PRODUCTS_DASHBOARD_DATA_SUCC="PRODUCTS_DASHBOARD_DATA_SUCC"

export const getAdminProductsDashboardReducer = (state: State = defaultState, action: AnyAction) => {
    switch (action.type) {
        case ADMIN_PRODUCTS_DASHBOARD_DATA_REQ:

            return {
                loading: true,
                data: state.data
            }
        case ADMIN_PRODUCTS_DASHBOARD_DATA_SUCC:

            return {
                loading: false,
                data: action.payload,

            }
        case ADMIN_PRODUCTS_DASHBOARD_DATA_FAIL:
            return {
                loading: false,
                error: action.payload
            }


        default:
            return state;
    }
}